import SubscriptionFlowModal from './containers/SubscriptionFlowModal';

export default SubscriptionFlowModal;
